import Vue from 'vue'

export default {
    UPDATE_EXPERTS (state, value) {
        Vue.set(state, 'experts', value);
    },
    SET_EXPERTS (state, value) {
        this.commit('UPDATE_EXPERTS', value);
    },
    SET_SELECTED_EXPERT (state,  value ) {
      Vue.set(state, 'selectedExpert', value);
    },
    SET_INTERESTS (state, value) {
        this.commit('UPDATE_INTERESTS', value);
    },
    UPDATE_INTERESTS (state, value) {
        localStorage.setItem('interests', JSON.stringify(value));
        Vue.set(state, 'interests', value);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/experts/mutations.js